import './style.css';
import 'typeface-roboto';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { StripeProvider } from 'react-stripe-elements';
import { PersistGate } from 'redux-persist/integration/react';

import App from './routes/App/';
import { ThemeProvider } from 'components/ThemeProvider';

import Theme from 'Theme';
import config from 'config';
import store, { persistor } from './store';

ReactDOM.render(
  <StripeProvider apiKey={config.stripe.key}>
    <ThemeProvider theme={Theme}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </ThemeProvider>
  </StripeProvider>,
  document.getElementById('root')
);
